// Header.js
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Logo from './Logo';
import './index.css';
import { useTheme } from './ThemeContext';

const Header = () => {
  const { theme, toggleTheme } = useTheme();
  const [animateLogo, setAnimateLogo] = useState(false);

  const handleLogoClick = () => {
    const logoElement = document.getElementById('logo');
    const rect = logoElement.getBoundingClientRect();
    const logoCenter = {
      top: rect.top + window.scrollY + rect.height / 2,
      left: rect.left + window.scrollX + rect.width / 2,
    };
    setAnimateLogo(true);
    toggleTheme(logoCenter);
  };

  useEffect(() => {
    if (animateLogo) {
      const timer = setTimeout(() => {
        setAnimateLogo(false);
      }, 1500);
      return () => clearTimeout(timer);
    }
  }, [animateLogo]);

  const logoColor = theme === 'dark' ? '#fff' : '#000';
  const textShadowColor = theme === 'dark' ? '255, 255, 255' : '0, 0, 0';

  const resetStyle = (e) => {
    e.currentTarget.style.transform = '';
    e.currentTarget.style.opacity = '';
    e.currentTarget.style.textShadow = '';
  };

  const closeMobileMenu = () => {
    // Close the mobile menu if necessary
  };

  return (
    <div style={{ paddingTop: '20px' }}>
      <header style={{
        backgroundColor: 'trasnparent',
        padding: '10px 20px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        fontFamily: '"Arial", sans-serif',
        position: 'relative',
        borderRadius: '50px',
        maxWidth: '30vh',
        margin: '0 auto'
      }}>
        <nav style={{
          display: 'flex',
          alignItems: 'center',
          width: '100%',
          justifyContent: 'center',
        }}>
          <Link to="/" className="font-space-grotesk font-semibold" style={{
            padding: '0 20px',
            textDecoration: 'none',
            fontSize: '18px',
            color: logoColor,
            transition: 'transform 0.3s, opacity 0.3s, text-shadow 0.3s',
            borderRadius: '25px',
          }} onClick={closeMobileMenu} onMouseOver={(e) => {
            e.currentTarget.style.transform = 'translateY(4px)';
            e.currentTarget.style.opacity = '1';
            e.currentTarget.style.textShadow = `0 10px 3px rgba(${textShadowColor}, 0.5), 0 20px 3px rgba(${textShadowColor}, 0.2)`;
          }} onMouseOut={resetStyle} onTouchEnd={resetStyle}>WORK</Link>

          <div id="logo" style={{
            width: '50px',
            height: '50px',
            backgroundColor: 'trasnparent',
            borderRadius: '25px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            margin: '0 20px',
          }}>
            <Logo color={logoColor} onClick={handleLogoClick} animate={animateLogo} />
          </div>

          <Link to="/profile" className="font-space-grotesk font-semibold" style={{
            padding: '0 20px',
            textDecoration: 'none',
            fontSize: '18px',
            color: logoColor,
            borderRadius: '25px',
            transition: 'transform 0.3s, opacity 0.3s, text-shadow 0.3s',
          }} onClick={closeMobileMenu} onMouseOver={(e) => {
            e.currentTarget.style.transform = 'translateY(4px)';
            e.currentTarget.style.opacity = '1';
            e.currentTarget.style.textShadow = `0 10px 3px rgba(${textShadowColor}, 0.5), 0 20px 3px rgba(${textShadowColor}, 0.2)`;
          }} onMouseOut={resetStyle} onTouchEnd={resetStyle}>PROFILE</Link>
        </nav>
      </header>
    </div>
  );
};

export default Header;
